import { ReactNode } from 'react';

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="px-4 pb-2">{children}</div>
);

export default Layout;
